import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  startSpinner,
  stopSpinner,
  showPopUp,
} from "../../../redux/authActions";
import { doGet, doPost } from "../../../utils/ajaxHelper";
import * as actions from "../actions/actionType";
import {
  fetchAgItemListSuccess,
  fetchAgItemQuestionsSuccess,
  fetchAgQuestionResponsesSuccess,
  featchResponseCommentsSuccess,
  submitUserResponseSuccess,
} from "../actions/autoGradeAction";

import { url } from "../../../utils/apiEndpoints";

export function* fetchResourceList(action) {
  try {
    yield put(startSpinner());
    const fetchURL = `${url.autograde.getAgItemList}?user_puid=${action.payload.user_puid}&district_id=${action.payload.district_id}`;
    const itemListData = yield call(doGet, fetchURL);
    if (itemListData.data.status === "success") {
      yield put(fetchAgItemListSuccess(itemListData.data.data));
    } else {
      yield put(fetchAgItemListSuccess(null));
    }
  } catch (error) {
    // yield put(showPopUp(501));
    yield put(fetchAgItemListSuccess(null));
  } finally {
    yield put(stopSpinner());
  }
}

export function* fetchResourceQuestions(action) {
  try {
    yield put(startSpinner());
    const fetchURL = `${url.autograde.getAgItemQuestions}?item_id=${action.payload.itemId}&itemtype_id=${action.payload.resTypeId}`;
    const questionDetail = yield call(doGet, fetchURL);
    if (questionDetail.data.status === "success") {
      yield put(fetchAgItemQuestionsSuccess(questionDetail.data.data));
    } else {
      yield put(fetchAgItemQuestionsSuccess(null));
    }
  } catch (error) {
    yield put(showPopUp(501));
    yield put(fetchAgItemQuestionsSuccess(null));
  } finally {
    yield put(stopSpinner());
  }
}

export function* fetchResourceQuestionResponses(action) {
  try {
    yield put(startSpinner());
    const fetchURL = `${url.autograde.getAgItemQuestionResponses}?item_id=${action.payload.itemId}&itemtype_id=${action.payload.resTypeId}&question_index=${action.payload.qIndexKey}&user_puid=${action.payload.user_puid}&district_id=${action.payload.district_id}`;
    const responses = yield call(doGet, fetchURL);
    if (responses.data.status === "success") {
      yield put(fetchAgQuestionResponsesSuccess(responses.data.data));
    } else {
      yield put(fetchAgQuestionResponsesSuccess(null));
    }
  } catch (error) {
    yield put(showPopUp(501));
    yield put(fetchAgQuestionResponsesSuccess(null));
  } finally {
    yield put(stopSpinner());
  }
}

export function* fetchResponseComments(action) {
  try {
    yield put(startSpinner());
    const fetchURL = `${url.autograde.getResponseFeedback}?result_id=${action.payload.resultId}&question_index=${action.payload.qIndexKey}&user_puid=${action.payload.user_puid}&district_id=${action.payload.district_id}`;
    const responses = yield call(doGet, fetchURL);
    if (responses.data.status === "success") {
      yield put(
        featchResponseCommentsSuccess({
          id: action.payload.resultId,
          data: responses.data.data,
        })
      );
    } else {
      yield put(featchResponseCommentsSuccess(null));
    }
  } catch (error) {
    // yield put(showPopUp(501));
    yield put(featchResponseCommentsSuccess(null));
  } finally {
    yield put(stopSpinner());
  }
}

export function* submitUserFeedback(action) {
  try {
    yield put(startSpinner());
    const fetchURL = url.autograde.submitUserFeedback;
    const responses = yield call(doPost, fetchURL, action.payload);
    if (responses.data.status === "success") {
      let payload = {
        id: action.payload.result_id,
        data: {
          user_puid: action.payload.user_puid,
          user_name: "",
          feedback_text: action.payload.user_feedback,
          comment_time: new Date(),
          score: action.payload.user_score,
        },
      };
      yield put(submitUserResponseSuccess(payload));
    } else {
      yield put(submitUserResponseSuccess(null));
    }
  } catch (error) {
    yield put(showPopUp(501));
    yield put(submitUserResponseSuccess(null));
  } finally {
    yield put(stopSpinner());
  }
}

export function* callFetchResourceList() {
  yield takeLatest(actions.FETCH_AG_ITEM_LIST, fetchResourceList);
}

export function* callfetchResourceQuestions() {
  yield takeLatest(actions.FETCH_AG_ITEM_QUESTIONS, fetchResourceQuestions);
}

export function* callFetchResourceQuestionResponses() {
  yield takeLatest(
    actions.FETCH_AG_QUESTION_RESPONSES,
    fetchResourceQuestionResponses
  );
}
export function* callFetchResponseComments() {
  yield takeLatest(actions.FETCH_RESPONSE_COMMENTS, fetchResponseComments);
}

export function* callSubmitUserFeedback() {
  yield takeLatest(actions.SUBMIT_USER_FEEDBACK, submitUserFeedback);
}

export function* autoGradeSaga() {
  yield all([
    callFetchResourceList(),
    callfetchResourceQuestions(),
    callFetchResourceQuestionResponses(),
    callFetchResponseComments(),
    callSubmitUserFeedback(),
  ]);
}
